<template>
  <v-dialog :value="value" @input="closeDialog" max-width="500px" persistent>
    <v-card dark rounded="xl">
      <v-sheet
        height="120px"
        :style="{ background: `linear-gradient(to right, var(--v-primary-base), #1de9b6)` }"
        class="d-flex justify-center align-center">
        <v-icon size="70" dark>mdi-account-group-outline</v-icon>
      </v-sheet>

      <v-card-title class="headline justify-center pt-6"> Neue Gruppe erstellen </v-card-title>

      <v-card-text class="pa-6">
        <v-form ref="form" v-model="isValid">
          <v-text-field
            v-model="groupName"
            label="Name für die Gruppe..."
            placeholder="z.B. Team roody"
            :rules="[rules.required]"
            filled
            rounded
            dense
            autofocus></v-text-field>

          <user-search
            v-model="tempSelectedUser"
            label="Mitglieder hinzufügen"
            :return-user="true"
            instructor
            :rights="'chat_create'"
            @update="addUserToList"
            class="mt-4" />

          <div class="mt-4">
            <div v-if="!selectedUsers.length" class="text-center grey--text text--darken-1">Noch keine Mitglieder hinzugefügt.</div>

            <v-sheet v-else color="grey darken-3" rounded="lg" class="pa-2" style="max-height: 160px; overflow-y: auto">
              <v-chip v-for="user in selectedUsers" :key="user._id" class="ma-1" pill close @click:close="removeUser(user)">
                <v-avatar left>
                  <v-img v-if="user.bild" :src="'/img/profilbilder/' + user.bild" alt="Profilbild"></v-img>
                                <v-icon v-else dark>mdi-account-group</v-icon>    
                </v-avatar>
                {{ user.vorname }} {{ user.nachname }}
              </v-chip>
            </v-sheet>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-6 pt-0">
        <v-btn text @click="closeDialog" :disabled="isSaving"> Abbrechen </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded depressed large @click="saveGroup" :loading="isSaving" :disabled="!isValid || !groupName.trim()">
          Gruppe erstellen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// 1. DEINE UserSearch-Komponente importieren
import userSearch from "@/components/userSearch" // Pfad ggf. anpassen
import { mapActions } from "vuex"

export default {
  name: "ChatGroupCreateDialog",

  // 2. Als Komponente registrieren
  components: {
    userSearch,
  },

  props: ["value"],

  data() {
    return {
      isValid: false,
      isSaving: false,

      groupName: "",

      // 3. WICHTIGE ÄNDERUNGEN:
      // Dieses Array hält die hinzugefügten User-OBJEKTE
      selectedUsers: [],
      // Dieses v-model ist NUR zum Füttern/Zurücksetzen der userSearch da
      tempSelectedUser: null,

      rules: {
        required: (v) => !!(v && v.trim()) || "Eingabe ist erforderlich.",
      },
    }
  },
  created() {
    console.log("olla i just appeard")
  },

  methods: {
    ...mapActions("chatStore", ["createGroup"]),

    /**
     * NEUE METHODE: Wird von @update der userSearch getriggert.
     * 'userObject' ist das, was deine Komponente mit :returnUser="true" sendet.
     */
    addUserToList(userObject) {
      // 1. Prüfen, ob ein User ausgewählt wurde
      if (!userObject) return

      // 2. Prüfen, ob der User schon in der Liste ist
      const isAlreadyAdded = this.selectedUsers.some((u) => u._id === userObject._id)
      if (isAlreadyAdded) {
        // Optional: Toast-Nachricht "User ist schon dabei"
      } else {
        // 3. User zur Liste hinzufügen
        this.selectedUsers.push(userObject)
      }

      // 4. WICHTIG: Die userSearch-Komponente zurücksetzen,
      // damit man sofort den nächsten suchen kann.
      this.$nextTick(() => {
        this.tempSelectedUser = null
      })
    },

    /**
     * Entfernt einen User aus der 'selectedUsers'-Chip-Liste
     */
    removeUser(userToRemove) {
      this.selectedUsers = this.selectedUsers.filter((u) => u._id !== userToRemove._id)
    },

    /**
     * Speichert die Gruppe
     */
    async saveGroup() {
      if (!this.$refs.form.validate()) return

      this.isSaving = true

      const payload = {
        name: this.groupName.trim(),
        // Wir mappen nur die IDs aus unseren gesammelten User-Objekten
        memberIds: this.selectedUsers.map((u) => u._id),
      }

      try {
        await this.createGroup(payload)
        this.$emit("group-created")
        this.resetAndClose()
      } catch (err) {
        console.error("Speichern fehlgeschlagen", err)
        // TODO: this.$toast.error("Speichern fehlgeschlagen")
      } finally {
        this.isSaving = false
      }
    },

    /**
     * Helfer-Funktion für die Avatar-Initialen
     */
    getInitials(user) {
      const v = user.vorname || ""
      const n = user.nachname || ""
      return `${v.charAt(0).toUpperCase()}${n.charAt(0).toUpperCase()}`
    },

    /**
     * Dialog schliessen und alles zurücksetzen
     */
    closeDialog() {
      if (this.isSaving) return
      this.$emit("input", false) // v-model auf false setzen

      // Kurzer Timeout, damit der Reset nicht sichtbar ist
      setTimeout(() => {
        this.groupName = ""
        this.selectedUsers = []
        this.tempSelectedUser = null
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      }, 300)
    },
  },
}
</script>

<style lang="scss" scoped>
/* Kleine Anpassung, damit die Chips im Sheet schön umbrechen */
.v-sheet.pa-2 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px; /* Abstand zwischen den Chips */
}
</style>
